module.exports = __webpack_public_path__ + "static/media/cloud-uploading.63c1ac3b.svg";